import { useCallback, useEffect } from "react";
import MessageBubble from "./MessageBubble";

// Bug fix: this used to call messagesEndRef.scrollIntoView() on a marker
// div at the bottom of the thread. scrollIntoView() walks up *every*
// scrollable ancestor to bring its target into view - including the page
// itself, not just this panel's own scroll box - so each new message (or
// even just the loading dots appearing/disappearing) could yank the whole
// page down well past the chat panel. Scrolling the panel's own scroll
// container (chat-panel-body, passed down as scrollContainerRef) directly
// via scrollTo() only ever affects that one element, never the page.
const MessageList = ({ messages, status, renderMessageExtras, scrollContainerRef }) => {
  const scrollToBottom = useCallback(() => {
    const container = scrollContainerRef?.current;
    if (!container) return;
    container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
  }, [scrollContainerRef]);

  useEffect(() => {
    scrollToBottom();
  }, [messages, status, scrollToBottom]);

  return (
    <div className="chat-messages">
      {messages.map(message => (
        <MessageBubble key={message.id} message={message}>
          {renderMessageExtras && renderMessageExtras(message)}
        </MessageBubble>
      ))}
      {status === "loading" && (
        <div className="chat-message assistant">
          <div className="chat-bubble-group">
            <div className="chat-bubble chat-bubble-loading">
              <span className="chat-bubble-prefix">Myracle Bot:</span>
              <span className="chat-bubble-typing" aria-label="Myracle Bot is typing">
                <span className="chat-bubble-typing-dot" />
                <span className="chat-bubble-typing-dot" />
                <span className="chat-bubble-typing-dot" />
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageList;
